export default "__VITE_ASSET__BZ6_Ergb__ 400w, __VITE_ASSET__WNBR$Fyn__ 800w, __VITE_ASSET__C1mDa8Wm__ 1024w";